// Exports the "fullpage" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/fullpage')
//   ES2015:
//     import 'tinymce/plugins/fullpage'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/plugins/fullpage/index.js
// module id = 589
// module chunks = 0